"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ItemCityTag;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    container: {
      display: "flex"
    },
    left: {
      flex: "50%"
    },
    right: {
      flex: "50%",
      textAlign: "right"
    }
  };
});

function ItemCityTag(_ref) {
  var id = _ref.id,
      title = _ref.title;
  var classes = useStyle();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.left
  }, /*#__PURE__*/_react["default"].createElement("span", null, title, " "), /*#__PURE__*/_react["default"].createElement("sup", null, "[", id, "]")));
}

ItemCityTag.propTypes = {
  title: _propTypes["default"].string,
  id: _propTypes["default"].number
};